export const trimMax = (set: Set<string>, max: number) => {
  const setArray = Array.from(set);
  if (setArray.length <= max) {
    return set;
  }
  const newSet = new Set<string>(setArray.slice(-max));
  return newSet;
};
